import { adultingColorTokens, adultingDarkColorTokens } from './tokens';

export const adultingThemes = {
  adultingLight: {
    background: adultingColorTokens.background,
    color: adultingColorTokens.foreground,
    colorMuted: adultingColorTokens.mutedForeground,
    colorInverse: adultingColorTokens.card,
    borderColor: adultingColorTokens.border,
    cardBackground: adultingColorTokens.card,
    cardForeground: adultingColorTokens.cardForeground,
    mutedBackground: adultingColorTokens.muted,
    inputBackground: adultingColorTokens.card,
    inputBorderColor: adultingColorTokens.input,
    primary: adultingColorTokens.primary,
    primaryForeground: adultingColorTokens.primaryForeground,
    secondary: adultingColorTokens.secondary,
    secondaryForeground: adultingColorTokens.secondaryForeground,
    accent: adultingColorTokens.accent,
    accentForeground: adultingColorTokens.accentForeground,
    success: adultingColorTokens.success,
    successForeground: adultingColorTokens.successForeground,
    destructive: adultingColorTokens.destructive,
    destructiveForeground: adultingColorTokens.destructiveForeground,
    primaryTint: adultingColorTokens.primaryTint,
    secondaryTint: adultingColorTokens.secondaryTint,
    accentTint: adultingColorTokens.accentTint,
    successTint: adultingColorTokens.successTint,
    destructiveTint: adultingColorTokens.destructiveTint,
    shadowColor: adultingColorTokens.shadow,
    overlayColor: adultingColorTokens.overlay,
  },
  adultingDark: {
    background: adultingDarkColorTokens.background,
    color: adultingDarkColorTokens.foreground,
    colorMuted: adultingDarkColorTokens.mutedForeground,
    colorInverse: adultingDarkColorTokens.card,
    borderColor: adultingDarkColorTokens.border,
    cardBackground: adultingDarkColorTokens.card,
    cardForeground: adultingDarkColorTokens.cardForeground,
    mutedBackground: adultingDarkColorTokens.muted,
    inputBackground: adultingDarkColorTokens.card,
    inputBorderColor: adultingDarkColorTokens.input,
    primary: adultingDarkColorTokens.primary,
    primaryForeground: adultingDarkColorTokens.primaryForeground,
    secondary: adultingDarkColorTokens.secondary,
    secondaryForeground: adultingDarkColorTokens.secondaryForeground,
    accent: adultingDarkColorTokens.accent,
    accentForeground: adultingDarkColorTokens.accentForeground,
    success: adultingDarkColorTokens.success,
    successForeground: adultingDarkColorTokens.successForeground,
    destructive: adultingDarkColorTokens.destructive,
    destructiveForeground: adultingDarkColorTokens.destructiveForeground,
    primaryTint: adultingDarkColorTokens.primaryTint,
    secondaryTint: adultingDarkColorTokens.secondaryTint,
    accentTint: adultingDarkColorTokens.accentTint,
    successTint: adultingDarkColorTokens.successTint,
    destructiveTint: adultingDarkColorTokens.destructiveTint,
    shadowColor: adultingDarkColorTokens.shadow,
    overlayColor: adultingDarkColorTokens.overlay,
  },
} as const;

export const adultingDefaultTheme = 'adultingLight' as const;
